import { render } from "./AdminConfiguracionUsuarios.vue?vue&type=template&id=2418404f&scoped=true"
import script from "./AdminConfiguracionUsuarios.vue?vue&type=script&lang=js"
export * from "./AdminConfiguracionUsuarios.vue?vue&type=script&lang=js"

import "./AdminConfiguracionUsuarios.vue?vue&type=style&index=0&id=2418404f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2418404f"]])

export default __exports__